import React, {useEffect, useState} from "react";
import {DatasetsApi} from "api/DatasetsApi";
import {AutoComplete, AutoCompleteChangeParams, AutoCompleteCompleteMethodParams} from "primereact/autocomplete";
import {DropdownItem} from "utils/general-models";

interface IDatasetMultiSelectProps {
    // Dataset identifier
    value?: string[] | null;
    onChange: (e: string[]) => void;
    style?: React.CSSProperties;
}

export function DatasetMultiSelect(props: IDatasetMultiSelectProps) {
    const [selectedDatasets, setSelectedDatasets] = useState<DropdownItem<string>[] | null>(null);
    const [filteredDatasets, setFilteredDatasets] = useState<DropdownItem<string>[]>([]);

    const [error, setError] = useState(false);

    useEffect(() => {
        if(props.value){
            DatasetsApi.queryDatasets(null, 0, props.value).then((r) => {
                if(!r.error && r.data){
                    const selections = r.data.map((it) => ({ value: it.identifier, label: it.toString() } as DropdownItem<string>))
                    setSelectedDatasets(selections);
                }
            });
        }
    }, [])

    const searchDatasets = (e: AutoCompleteCompleteMethodParams) => {
        DatasetsApi.queryDatasets(e.query, 100).then((r) => {
            if(!r.error && r.data){
                const selections = r.data.map((it) => ({ value: it.identifier, label: it.toString() } as DropdownItem<string>))
                setFilteredDatasets(selections)
            } else {
                setError(true)
            }
        });
    }

    const onChange = (e: AutoCompleteChangeParams) => {
        setSelectedDatasets(e.value);

        if(typeof e.value === "string") return; // Ignore string auto complete dumb input

        props.onChange(e.value?.map((item:DropdownItem<string>) => item.value) || null);
    }

    return <>
            <AutoComplete placeholder="Select Dataset"
                          multiple={true}
                          value={selectedDatasets}
                          suggestions={filteredDatasets}
                          onChange={onChange}
                          completeMethod={searchDatasets}
                          minLength={3}
                          field="label"
                          dropdownMode="blank"
                          style={{width: "100%", ...props.style}}
                          dropdown
            />
    </>
}